import React, { useEffect } from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Helmet } from '@dr.pogodin/react-helmet';

const BreadcrumbSchemaModel = ({ fields }) => {
  const script = getFieldValue(fields, 'script');
  useEffect(() => {
    if (document && document.URL && script) {
      script.url = document.URL.split('?')[0].split('#')[0];
    }
  }, [script]);

  return (
    <Helmet>
      <script defer type='application/ld+json'>
        {JSON.stringify(script)}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchemaModel;
